import { Box } from '@components/Box';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery } from '@utils/styledTheme.util';
import styled from 'styled-components';

export const StyledCardWrapper = styled(Box)`
  .text-pairing-title {
    max-width: 75%;
  }
  ${themeMediaQuery('md')} {
    .text-pairing-title {
      max-width: 346px;
    }
  }
`;
